import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Section, Eyebrow, SectionTitle } from './ui.jsx';
import { tokens, monoFont } from '../theme.js';

export default function Approach() {
  const { t } = useTranslation();
  const items = t('approach.items', { returnObjects: true });

  return (
    <Section id="approach" sx={{ bgcolor: tokens.cream }}>
      <Eyebrow>{t('approach.eyebrow')}</Eyebrow>
      <SectionTitle>{t('approach.title')}</SectionTitle>
      <Typography sx={{ color: 'text.secondary', maxWidth: '68ch', mt: -3, mb: 5 }}>{t('approach.intro')}</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3 }}>
        {items.map((item, index) => (
          <Box key={item.title} sx={{ borderTop: `2px solid ${tokens.teal}`, pt: 2.5 }}>
            <Typography sx={{ fontFamily: monoFont, fontSize: '0.72rem', color: 'primary.dark' }}>{String(index + 1).padStart(2, '0')}</Typography>
            <Typography variant="h3" sx={{ my: 1.25 }}>{item.title}</Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.95rem' }}>{item.body}</Typography>
          </Box>
        ))}
      </Box>
    </Section>
  );
}
